export default {
  title: {
    en: 'Reactivate your account',
  },
  text: {
    en: `
      Unfortunately, only active subscribers have exclusive access to all fragrance, makeup
      and skincare products. We noticed that your billing info is not up-to-date.
    `,
  },
  buttonTitle: {
    en: 'Reactivate your account',
  },
  footerText: {
    en: 'No, I do not want to save money and try awesome beauty products',
  },
}
